import React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import WheelTypeService from "src/service/wheel";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Wheel Type",
  },
];

const validationSchema = yup.object({
  wheel_type: yup
    .string("vehicle wheel No")
    .min(1, "vehicle wheel No should be of minimum 1 characters in length")
    .max(30, "vehicle wheel No should be of maximum 30 characters in length")
    .required("vehicle wheel No is required"),
});

const AddWheelType = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const initialValues = {
    // admin_id: sessionData.data.id,
    wheel_type: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await WheelTypeService.addWheelType(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/wheelType");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Add Wheel No" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Wheel Type
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/wheelType");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/*   ==== manufacturer name  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="wheel_type">
                No of Wheels <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="wheel_type"
                name="wheel_type"
                type="text"
                value={values.wheel_type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.wheel_type && Boolean(errors.wheel_type)}
                helperText={touched.wheel_type && errors.wheel_type}
                variant="outlined"
                placeholder="Enter wheel type"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddWheelType;
